import { Box, Typography } from "@mui/material";
import UniversalDescriptorList from "./UniversalDescriptorList";

const UniversalDescriptorManagerLandingPage = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant='h5' gutterBottom>
        Universal Descriptor Manager
      </Typography>
      <UniversalDescriptorList />
    </Box>
  );
};

export default UniversalDescriptorManagerLandingPage;
